module.exports = __webpack_public_path__ + "img/website_design.63c403d4.png";